<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (OnSave)="Save()"></app-form-save-button>
    </app-pageheader>
  </div>
}

<app-level-designer #levelDesigner ></app-level-designer>

<!--
<app-levelmapeditor #levelMapEditor *ngIf="FormLoaded == true" [ModelEditor]="this" [Level]="Form"></app-levelmapeditor>

<app-leveleditor #levelEditor *ngIf="FormLoaded == true" [ModelEditor]="this" [Level]="Form"></app-leveleditor>-->